import { logError } from '@/src/logger';
import { NOT_SET, track } from '@/src/utils/tracking';
import getOriginEvent from '@/src/utils/tracking/getOriginEvent';
import { getScreenName } from './utilsTracking';

const shopClicked = ({
  origin,
  shopGoldVip = NOT_SET,
  ncrRequestToken = NOT_SET,
  shopSponsoring = NOT_SET,
  midasRequestId = NOT_SET,
  shopId = NOT_SET,
  currencyCode = NOT_SET,
  shopRatingQuality = NOT_SET,
  shopName = NOT_SET,
  shopDeliveryFee = NOT_SET,
  shopDeliveryTime = NOT_SET,
  position = NOT_SET,
  shopListBusinessType = NOT_SET,
  shopDistance = NOT_SET,
  bannerName = NOT_SET,
  bannerId = NOT_SET,
  screenType = 'vendors_landing',
  rankingRequestId,
  landingId,
  landingTitle,
  landingType,
}) => {
  const EVENT_NAME = 'shop.clicked';
  const isItemLanding = screenType === 'items_landing';

  try {
    const payload = {
      shopGoldVip,
      ncrRequestToken: ncrRequestToken || NOT_SET,
      shopSponsoring,
      midasRequestId,
      shopClickOrigin: isItemLanding
        ? getOriginEvent(origin, isItemLanding).shopClickOrigin
        : 'global_organic_list',
      shopSponsoringPlacement: getOriginEvent(origin, isItemLanding)
        .shopSponsoringPlacement,
      shopId,
      screenType,
      currencyCode,
      shopRatingQuality,
      shopName,
      shopDeliveryFee,
      shopDeliveryTime,
      position,
      shopListBusinessType,
      shopDistance,
      bannerName: bannerName || NOT_SET,
      bannerId: bannerId || NOT_SET,
      screenName: getScreenName(landingType),
      rankingRequestId,
      landingId,
      landingTitle,
    };
    track(EVENT_NAME, payload, {
      logEventKey: `[${EVENT_NAME}]`,
      sendToLogs: true,
    });
  } catch (e) {
    logError(EVENT_NAME, e);
  }
};

export default shopClicked;
